export default __webpack_public_path__ + "static/media/img-colored-logo-text.b9904ae2.jpg";